module.exports = __webpack_public_path__ + "img/xp.f2362c26.png";